import { EMPTY_OBJECT } from '../constants';
import { replaceVariablesInRichText } from './replaceVariablesInRichText';
import { PrismicContentSerializer } from '@monofront/types';

export const prismicRichTextContentSerializer =
  (
    replacements: Record<string, string> = EMPTY_OBJECT,
  ): PrismicContentSerializer =>
  (text) =>
    replaceVariablesInRichText(text, replacements);
